// extracted by mini-css-extract-plugin
export default {"wordpressPCMenu":"Wordpress_wordpressPCMenu__4IacB","wordpressPhoneMenu":"Wordpress_wordpressPhoneMenu__hm+M7"};